module.exports = __webpack_public_path__ + "static/media/Eye_open.1a0fa4c1.svg";